/**
 * Implements a Backbone Brace mixin that validates a role, when it exists.
 */

import Radio from "backbone.radio";
import { isArray, isEmpty } from "underscore";

const channel = Radio.channel("global");

const RoleValidator = {
  namedAttributes: {
    roles: [String],
    validRole: Boolean,
  },

  defaults: {
    roles: null,
    validRole: true,
  },

  initialize() {
    // validate roles
    const roles = this.getRoles();
    if (isArray(roles) && !isEmpty(roles)) {
      const valid = channel.request("user:has-any-role", roles);
      // console.log("Are %s valid?", roles.join(","), valid);
      this.setValidRole(valid);
    }
  },
};

export { RoleValidator as default };
